module.exports = __webpack_public_path__ + "static/Certicat-9d518f1820238fcd2e43269ecde548c9.png";